import videojs from "video.js";

const ClickableComponent = videojs.getComponent('ClickableComponent');

class GroupWithQualitySwitchButton extends ClickableComponent {
	constructor(player, options) {
		super(player, options);

		this.addClass('vjs-group-with-quality__switch');
	}

	addChild(...args) {
		super.addChild(...args);
		const [ child ] = args;

		// Обновляет иконку и title кнопки при изменении качества.
		if (child !== 'GroupWithQualityModalMenu') return;
		this.getChild('GroupWithQualityModalMenu').on(
			['quality-selected', 'qualities-updated'],
			() => {
				const selectedQuality = this.player().quality_handler.qualities.list.find((quality) => quality.selected);
				if (!selectedQuality) return;
				const resolutionHeight = selectedQuality.representation
					? selectedQuality.representation.height
					: 'auto';
				this.$('.vjs-icon-placeholder').setAttribute('data-resolution-height', resolutionHeight);
				this.controlText(selectedQuality.label);
				this.trigger('updateLabel');
			}
		);
	}
}

videojs.registerComponent('GroupWithQualitySwitchButton', GroupWithQualitySwitchButton);
